(() => {
  document.querySelectorAll('[data-artroom]').forEach(section => {
    if(section.dataset.initialized)return;section.dataset.initialized='true';
    const frame=section.querySelector('[data-presentation-frame]');if(!frame)return;
    let origin;try{origin=new URL(section.dataset.appOrigin).origin;}catch{return;}
    let ready=false,pending=null,cropping=false;
    const post=message=>{if(ready)frame.contentWindow.postMessage(message,origin);else pending=message;};
    const send=action=>post({type:'fleury-artroom-action',action});
    const scrollToTool=(offset=0,instant=false)=>{const header=document.querySelector('.fa-header'),style=header&&getComputedStyle(header);const inset=header&&['sticky','fixed'].includes(style.position)?Math.max(24,header.getBoundingClientRect().height+12):24;const top=frame.getBoundingClientRect().top+window.scrollY+Math.max(0,Math.min(frame.clientHeight,offset))-inset;window.scrollTo({top:Math.max(0,top),behavior:instant||matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    let selection=null,bar=null,barCount=null,barChips=null,barCreate=null,barFrame=null;
    const chips=new Map();
    const shortText=(v,n)=>typeof v==='string'&&v.length<=n;
    const validBounds=b=>b&&Number.isFinite(b.top)&&Number.isFinite(b.bottom)&&b.top>=0&&b.bottom>=b.top&&b.bottom<=30000;
    const updateBar=()=>{
      barFrame=null;if(!bar)return;
      const viewport=window.visualViewport,viewportBottom=viewport?viewport.offsetTop+viewport.height:innerHeight;
      const frameTop=frame.getBoundingClientRect().top;
      const keyboard=viewport&&innerHeight-viewport.height>140;
      const footerVisible=selection&&frameTop+selection.footer.top<viewportBottom&&frameTop+selection.footer.bottom>0;
      bar.hidden=!selection?.active||cropping||keyboard||!!section.querySelector('dialog[open]')||footerVisible||frameTop+selection.gallery.top>=viewportBottom||frameTop+selection.gallery.bottom<=0;
    };
    const scheduleBar=()=>{if(!barFrame)barFrame=requestAnimationFrame(updateBar);};
    const receiveSelection=data=>{
      if(typeof data.active!=='boolean'||typeof data.disabled!=='boolean'||!shortText(data.label,180)||!shortText(data.count,180)||!shortText(data.createLabel,180)||!validBounds(data.gallery)||!validBounds(data.footer)||!Array.isArray(data.items)||data.items.length>3||new Set(data.items.map(x=>x?.id)).size!==data.items.length||data.items.some(x=>!x||typeof x.id!=='string'||!/^[-a-f0-9]{36}$/.test(x.id)||!shortText(x.title,180)||!shortText(x.removeLabel,260))){selection=null;scheduleBar();return;}
      selection=data;
      if(!bar){
        bar=document.createElement('aside');bar.className='fa-artroom__selection';bar.hidden=true;bar.setAttribute('role','region');
        const top=document.createElement('div');top.className='fa-artroom__selection-top';barCount=document.createElement('p');barCount.setAttribute('aria-live','polite');
        barCreate=document.createElement('button');barCreate.type='button';barCreate.className='fa-artroom__button';barCreate.addEventListener('click',()=>{if(selection?.active&&!selection.disabled)post({type:'fleury-artroom-action',action:'create'});});
        top.append(barCount,barCreate);barChips=document.createElement('div');barChips.className='fa-artroom__selection-chips';bar.append(top,barChips);section.append(bar);
      }
      bar.setAttribute('aria-label',data.label);if(barCount.textContent!==data.count)barCount.textContent=data.count;if(barCreate.textContent!==data.createLabel)barCreate.textContent=data.createLabel;barCreate.disabled=data.disabled;
      for(const [id,button]of chips)if(!data.items.some(x=>x.id===id)){button.remove();chips.delete(id);}
      for(const item of data.items){let button=chips.get(item.id);if(!button){button=document.createElement('button');button.type='button';button.addEventListener('click',()=>post({type:'fleury-artroom-action',action:'deselect',sceneId:item.id}));chips.set(item.id,button);barChips.append(button);}button.textContent=item.title+' ×';button.setAttribute('aria-label',item.removeLabel);button.disabled=data.disabled;}
      scheduleBar();
    };
    addEventListener('scroll',scheduleBar,{passive:true});addEventListener('resize',scheduleBar,{passive:true});window.visualViewport?.addEventListener('resize',scheduleBar);new ResizeObserver(scheduleBar).observe(frame);
    const receive=event=>{
      if(event.origin!==origin||event.source!==frame.contentWindow)return;
      if(event.data?.type==='fleury-artroom-selection')receiveSelection(event.data);
      if(event.data?.type==='fleury-presentation-height' && Number.isFinite(event.data.height))frame.height=String(Math.min(30000,Math.max(480,Math.ceil(event.data.height))));
      if(event.data?.type==='fleury-artroom-ready'){const firstReady=!ready;ready=true;if(firstReady)frame.contentWindow.postMessage({type:'fleury-artroom-handshake',capabilities:{selectionBar:true}},origin);if(pending){frame.contentWindow.postMessage(pending,origin);pending=null;}}
      if(event.data?.type==='fleury-artroom-crop-open'){
        const data=event.data;if(cropping||typeof data.requestId!=='string'||data.requestId.length>80)return;
        const reply=(result,error=false)=>frame.contentWindow.postMessage({type:'fleury-artroom-crop-result',requestId:data.requestId,result,error},origin);
        if(!(data.blob instanceof Blob)||!['image/png','image/jpeg','image/webp'].includes(data.blob.type)||data.blob.size>25*1024*1024||!window.FleuryArtroomCrop){reply(null,true);return;}
        cropping=true;scheduleBar();window.FleuryArtroomCrop.open({blob:data.blob,rotation:data.rotation,crop:data.crop,labels:data.labels}).then(result=>reply(result)).catch(()=>reply(null,true)).finally(()=>{cropping=false;scheduleBar();});
      }
      if(event.data?.type==='fleury-artroom-scroll'&&Number.isFinite(event.data.top)){const top=event.data.top,instant=event.data.instant===true;requestAnimationFrame(()=>scrollToTool(top,instant));}
      if(event.data?.type==='fleury-artroom-preview'){
        const d=event.data;if(typeof d.id!=='string'||!/^[-a-f0-9]{36}$/.test(d.id)||typeof d.image!=='string')return;
        let previewUrl;try{previewUrl=new URL(d.image);}catch{return;}
        if(previewUrl.protocol!=='https:'||previewUrl.username||previewUrl.password||previewUrl.port||previewUrl.hostname!=='cdn.shopify.com'||!previewUrl.pathname.startsWith('/s/files/1/0673/3073/6413/files/'))return;
        section.querySelector('.fa-artroom__preview')?.remove();const dialog=document.createElement('dialog');dialog.className='fa-artroom__preview';
        const close=document.createElement('button');close.className='fa-artroom__preview-close';close.type='button';close.textContent=String(d.close).slice(0,80);close.addEventListener('click',()=>dialog.close());
        const image=document.createElement('img');image.src=previewUrl.href;image.alt=String(d.title).slice(0,180);
        const h=document.createElement('h2');h.id='artroom-preview-title';h.textContent=image.alt;dialog.setAttribute('aria-labelledby',h.id);
        const p=document.createElement('p');p.textContent=String(d.description).slice(0,500);const choose=document.createElement('button');choose.className='fa-artroom__button';choose.type='button';choose.disabled=!!d.disabled;choose.textContent=String(d.label).slice(0,100);choose.addEventListener('click',()=>{frame.contentWindow.postMessage({type:'fleury-artroom-select-preview',id:d.id},origin);dialog.close();});
        dialog.append(close,image,h,p,choose);section.append(dialog);dialog.addEventListener('close',()=>{dialog.remove();scheduleBar();},{once:true});dialog.showModal();scheduleBar();
      }
    };
    addEventListener('message',receive);
    const handshake=()=>{ready=false;selection=null;scheduleBar();frame.contentWindow.postMessage({type:'fleury-artroom-handshake',capabilities:{selectionBar:true}},origin);};
    frame.addEventListener('load',handshake);handshake();
    section.querySelectorAll('[data-artroom-action]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();scrollToTool();send(link.dataset.artroomAction);}));
    section.addEventListener('shopify:section:unload',()=>removeEventListener('message',receive),{once:true});
  });
})();

/* A real, swipeable example carousel, without imitation likes or actions. */
(() => {
  document.querySelectorAll('[data-artroom-feed]').forEach(feed => {
    if (feed.dataset.initialized) return;
    feed.dataset.initialized = 'true';
    const slides = feed.querySelector('.ar-feed__slides');
    const dots = [...feed.querySelectorAll('[data-feed-index]')];
    const previous = feed.querySelector('[data-feed-previous]');
    const next = feed.querySelector('[data-feed-next]');
    const count = feed.querySelector('[data-feed-count]');
    if (!slides || !dots.length) return;
    const current = () => Math.min(dots.length - 1, Math.max(0, Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth))));
    const update = () => {
      const index = current();
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      previous.disabled = index === 0;
      next.disabled = index === dots.length - 1;
      count.textContent = `${index + 1} / ${dots.length}`;
    };
    const go = index => slides.scrollTo({left: Math.min(dots.length - 1, Math.max(0, index)) * slides.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
    previous.addEventListener('click', () => go(current() - 1));
    next.addEventListener('click', () => go(current() + 1));
    slides.addEventListener('scroll', update, {passive: true});
    slides.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? dots.length - 1 : current() + (event.key === 'ArrowRight' ? 1 : -1));
    });
    update();
  });
})();

/* Native Artroom dialog actions: synced from public/fa-link-hover.js.
   Shopify already owns the effect on anchors; do not attach twice. */
/* Shared storefront effect, with native Artroom text actions included.
   Keep text and pseudo-elements intact; scene cards are not action targets. */
(() => {
  if (window.__fleuryArtroomActionHover) return;
  window.__fleuryArtroomActionHover = true;

  const ignoredText = 'script, style, svg, [hidden], [aria-hidden="true"], .visually-hidden, .sr-only';
  const actionSelector = 'button.fa-artroom__button, button.fa-artroom__preview-close, button.fa-crop-apply, button.fa-crop-cancel, button.fa-crop-reset';
  let layer;
  let activeLink;
  let frame;

  function existingMenuEffect(link) {
    const menu = link.closest('.fm-menu');
    if (!menu) return false;
    const preset = menu.dataset.preset;
    return (preset === 'fleury-header' || preset === 'fleury-mobile') &&
      (Boolean(link.closest('.fm-panel')) || preset === 'fleury-header');
  }

  function clear() {
    activeLink?.removeAttribute('data-fa-link-hover-active');
    activeLink = null;
    layer?.replaceChildren();
  }

  function rectangles(link) {
    const target = link.querySelector('[data-fa-link-label]') || link;
    const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
    const rows = [];
    const range = document.createRange();
    let text;

    while ((text = walker.nextNode())) {
      if (!text.textContent.trim() || text.parentElement.closest(ignoredText)) continue;
      range.selectNodeContents(text);
      for (const rect of range.getClientRects()) {
        if (rect.width < 1 || rect.height < 1) continue;
        const row = rows.find((candidate) => Math.abs(candidate.bottom - rect.bottom) <= 4);
        if (row) {
          row.left = Math.min(row.left, rect.left);
          row.right = Math.max(row.right, rect.right);
          row.bottom = Math.max(row.bottom, rect.bottom);
        } else {
          rows.push({ left: rect.left, right: rect.right, bottom: rect.bottom });
        }
      }
    }
    range.detach();

    // Image- and icon-only links receive the line along their own lower edge.
    // Empty stretched links use their bounds without changing their hit target.
    if (!rows.length) {
      const rect = link.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        rows.push({ left: rect.left, right: rect.right, bottom: rect.bottom - 4 });
      }
    }
    return rows;
  }

  function draw(link, animate = true) {
    if (!link?.isConnected || link.matches(':disabled') || link.getAttribute('aria-disabled') === 'true' || existingMenuEffect(link)) {
      clear();
      return;
    }
    if (link !== activeLink) clear();
    activeLink = link;
    link.setAttribute('data-fa-link-hover-active', '');
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'fa-link-hover-layer';
      layer.setAttribute('aria-hidden', 'true');
    }
    // Modal dialogs are in the browser's top layer, above body decorations.
    const host = link.closest('dialog[open]') || document.body;
    if (layer.parentElement !== host) host.append(layer);
    const lines = rectangles(link).map((rect) => {
      const line = document.createElement('span');
      line.className = 'fa-link-hover-line';
      line.style.left = `${rect.left}px`;
      line.style.top = `${rect.bottom + 1}px`;
      line.style.width = `${Math.max(0, rect.right - rect.left)}px`;
      if (!animate) line.style.animation = 'none';
      return line;
    });
    layer.replaceChildren(...lines);
  }

  function closestLink(target) {
    return target instanceof Element ? target.closest(actionSelector) : null;
  }

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const link = closestLink(event.target);
    if (!link) return;
    if (link.contains(event.relatedTarget)) return;
    draw(link);
  });

  document.addEventListener('pointerout', (event) => {
    const link = closestLink(event.target);
    if (link !== activeLink || link?.contains(event.relatedTarget)) return;
    const focused = closestLink(document.activeElement);
    if (focused?.matches(':focus-visible')) draw(focused, false);
    else clear();
  });

  document.addEventListener('focusin', (event) => {
    const link = closestLink(event.target);
    if (link?.matches(':focus-visible')) draw(link);
  });
  document.addEventListener('focusout', (event) => {
    if (closestLink(event.target) === activeLink) clear();
  });

  // Scrollable drawers and sticky headers can move a link without a pointer event.
  document.addEventListener('scroll', () => {
    if (!activeLink || frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      if (activeLink?.matches(':focus-visible')) draw(activeLink, false);
      else clear();
    });
  }, { passive: true, capture: true });
  window.addEventListener('resize', clear, { passive: true });
  window.addEventListener('blur', clear);
  document.addEventListener('click', clear);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') clear();
  });
})();
